<!-- HEADING PART -->
<p-card>
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12 createnewbtn">
      <div class="text-end p-0 border-round-sm font-bold" *ngIf="loginuserid==0">
        <p-button pTooltip="Add Configuration" tooltipPosition="left" (click)="show('Add Configuration','')"
          styleClass="customAdd p-button-sm p-button-raised mr-1" icon="pi pi-plus"></p-button>
      </div>
      <div class="text-end p-0 border-round-sm font-bold text-blue-500" *ngIf="loginuserid!=0">
        **please log out and log in to see the reflected changes.
      </div>
    </div>
  </div>

  <div class=" mr-0 tablehiegt">
    <p-table #dt [value]="tableData" [rows]="rowsize" [scrollable]="true" scrollDirection="horizontal"
      scrollHeight="{{commonScrollHeight}}" (sortFunction)="customSort($event)" [customSort]="true"
      [globalFilterFields]="['mainkey','subkey','productinitial','title','description','keyvalue']"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      (onPage)="handlePageChange($event)" [rowsPerPageOptions]="paginatorArray" dataKey="id" [rowHover]="true"
      [showCurrentPageReport]="true" [resizableColumns]="true" sortField="productinitial" columnResizeMode="expand"
      [first]="currentPageIndex" paginatorLocale="fa-IR" [paginator]="tableData.length>0" responsiveLayout="scroll">
      <!-- search -->
      <ng-template pTemplate="caption">
        <div class="grid table-header">
          <div class="col-12 md:col-10 sm:col-12 lg:col-10">
            <span class=" p-input-icon-lft">
              <i icon="pi pi-search"></i>
              <input class="form-control" pInputText type="text" id="tablesearch"
                (input)="dt.filterGlobal($any($event.target).value , 'contains') ; searchTerm = $any($event.target).value;"
                placeholder="Search in Application Configuration" class="tablesearch" pTooltip="Enter Search Criteria"
                tooltipPosition="top" />
            </span>
          </div>
          <div class="col-12 sm:col-2 md:col-2 sm:col-12 ">
            <div class="iconexcel" pTooltip="Download Data" tooltipPosition="bottom" style="cursor: pointer;"
              (click)="showDialog()"></div>
          </div>
        </div>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th style="width: 5px !important;" class="tableaction">Action</th>
          <ng-container *ngFor="let col of _selectedColumns">
            <th pResizableColumn [pSortableColumn]="col.field" *ngIf="col.isChecked">
              {{col.header}}<p-sortIcon [field]="col.field"></p-sortIcon>
              <p-columnFilter type="text" [field]="col.field" display="menu"></p-columnFilter>

            </th>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data>
        <tr>
          <td style="width: 5px !important; vertical-align: top;">
            <div style="display: flex; align-items: flex-start;">
              <span class="actionItm" pTooltip="Modify" tooltipPosition="left">
                <i class="fa fa-edit" (click)="show('Modify Configuration',data)"></i>
              </span>
            </div>
          </td>
          <ng-container *ngFor="let col of _selectedColumns">
            <td style="vertical-align: top;" *ngIf="col.isChecked" [style.width]="col.width" [class]="col.class">
              <span pTooltip=" {{data[col.field]}}" class="wrap-text"
                [innerHTML]="highlight(data[col.field],searchTerm)"></span>
            </td>
            <!-- <td style="vertical-align: top;" *ngIf="col.isChecked" [style.width]="col.width" [class]="col.class"  >
                <span *ngIf="col.field!=='activeflag'" class="wrap-text"  pTooltip=" {{data[col.field] }}">  {{data[col.field] }}</span>
                <span *ngIf="col.field=='activeflag'" >
                  <i *ngIf="data[col.field]=== 'Y'" pTooltip="Active" tooltipPosition="left" class="fa fa-flag" aria-hidden="true" style="color: green;"></i>
                  <i *ngIf="data[col.field]!== 'Y'" pTooltip="Inactive" tooltipPosition="left" class="fa fa-flag" aria-hidden="true" style="color: red;"></i>
                </span>
              </td> -->
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="7" class="datanotfound">
            No data available
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</p-card>

<!--        
    
  <p-dialog header="Excel Download" [(visible)]="exceldownloadModal" [modal]="true" [baseZIndex]="10000"
  [draggable]="true" [resizable]="false" position="center">
  <div class="dialog-content-min-excel" style=" text-align: center !important;">
    <div class="card">
      <p>{{excel_paragraph}}</p>
    </div>
  </div>
  
  <div class="custom-dialog-footer">
    <p-button class="m-1 w-full" label="Close" styleClass="customeclose" (click)="exceldownloadModal=false"></p-button>
    <p-button class="m-1 w-full" label="Download" styleClass="customesave" (click)="downloadgridexcel()"></p-button>
  </div>
  </p-dialog>
   -->